<ng-container *ngIf="!isCustom">
  <ft-literature-document-card
    *ngFor="let data of rowData; let last = last"
    edsCol
    [columnNumbers]="{ s: 4, m: 8, l: 10 }"
    [edsSpacing]="last ? 'sm' : 'md'"
    [rowData]="data"
    [columnDefs]="columnDefs"
    [gridContext]="gridContext"
    (selectionEmitter)="onSelectionChanged($event)"
  >
  </ft-literature-document-card>
</ng-container>
<ng-container *ngIf="isCustom">
  <ft-literature-custom-document-card
    *ngFor="let data of rowData; let last = last"
    edsCol
    [columnNumbers]="{ s: 4, m: 8, l: 10 }"
    [edsSpacing]="last ? 'sm' : 'md'"
    [rowData]="data"
    [columnDefs]="columnDefs"
    [gridContext]="gridContext"
  >
  </ft-literature-custom-document-card>
</ng-container>
